import Block from '@uiw/react-color-block';
import APopover from 'components/APopover';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { border1 } from 'utils/style/colors';

interface IColorPicker {
  color: string;
  onChangeColor: (color: string) => void;
  hideLabel: boolean;
  size: 'small' | 'normal';
}

const SquereColorPicker = styled.div`
  margin: 0.5rem 0;
  background-color: ${(props) => props.color};
  border: ${border1};

  ${(props) => {
    return props.size === 'small'
      ? 'height: 1.5rem; width: 1.5rem; border-radius: 0.25rem'
      : 'height: 2.2rem; width: 2.2rem; border-radius: 0.8rem';
  }}
`;

const ColorPicker: FC<IColorPicker> = ({
  color,
  onChangeColor,
  hideLabel = false,
  size = 'normal',
}) => {
  const { t } = useTranslation('survey');

  return (
    <div>
      {!hideLabel && <label>{t('color', { ns: 'survey' }) as string}</label>}
      <APopover
        target={<SquereColorPicker size={size} color={color} />}
        arrow
        placement={'bottom'}
      >
        <div>
          <Block
            color={color}
            onChange={(c) => {
              onChangeColor(c.hexa);
            }}
          />
        </div>
      </APopover>
    </div>
  );
};

export default ColorPicker;
